var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-title',{directives:[{name:"linkified",rawName:"v-linkified"}]},[_vm._v(" "+_vm._s(_vm.message.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }